<template>
	<v-sheet dark class="mx-auto surfaceDark darken-2" color="white">
		<v-slide-group v-model="model" center-active class="d-flex flex-nowrap">
			<v-slide-item v-for="(card, i) in pocketGameList" :key="i" v-slot="{ toggle }">
				<v-card rounded :ripple="false" dark width="165" class="ma-2" @click="toggle">
					<v-hover v-slot="{ hover }">
						<v-img
							transition="scroll-y-transition"
							:src="card.src"
							class="white--text align-end shrink"
							gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5) 200%"
							height="135"
						>
							<v-expand-transition v-if="$vuetify.breakpoint.mdAndUp">
								<div
									v-if="hover"
									class="d-flex transition-fast-in-fast-out justify-center"
									style="background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(255,255,255,0) 100%)"
								>
									<div class="d-flex flex-column my-6 mx-auto">
										<v-btn color="secondary darken-5" class="mb-2">play now</v-btn>
										<v-btn text color="white">free play</v-btn>
									</div>
									<div class="d-flex align-end justify-end ml-n8 pa-1">
										<v-btn icon small>
											<v-icon small color="blue"> mdi-information-outline </v-icon>
										</v-btn>
									</div>
								</div>
							</v-expand-transition>
						</v-img>
					</v-hover>
					<v-card-actions>
						<v-row class="d-flex flex-column">
							<v-col class="pa-2">
								<v-card-text class="text-body-2 pa-0 mb-4">{{ card.title }}</v-card-text>
								<v-col class="my-n2 pa-0">
									<v-rating
										v-model="card.rating"
										background-color="white"
										color="orange accent-4"
										dense
										half-increments
										hover
										size="12"
										class="mb-n2"
									></v-rating>
									<span class="text-caption grey--text mt-n2">{{ `${card.userRating}+ ratings` }}</span>
								</v-col>
							</v-col>
						</v-row>
					</v-card-actions>
				</v-card>
			</v-slide-item>
		</v-slide-group>
	</v-sheet>
</template>

<script>
export default {
	data() {
		return {
			model: null,
		}
	},
	computed: {
		pocketGameList() {
			return this.$store.getters["Casino/pocketGameList"]
		},
	},
}
</script>

<style lang="sass" scoped>
.v-card
	transition: .1s ease-in-out
	&:hover
		transform: translateY(-0.5rem)

.v-card:not(.on-hover)
	opacity: 1

.v-card__actions
	height: 6rem

.round-border
	border-radius: 3rem !important
.v-slide-group__next, .v-slide-group__prev
	min-width: 36px
</style>
